import { Component, useState } from "react";
import { Button, Flex, Text, useToast } from "@chakra-ui/react";

class ChatErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ChatErrorBoundary caught an error", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    this.props.onRetry?.();
  };

  render() {
    const { hasError, error } = this.state;
    const { Lang } = this.props;
    if (hasError) {
      return (
        <Flex
          flex={1}
          align="center"
          justify="center"
          direction="column"
          bg="surface.900"
          color="white"
          gap={4}
          p={6}
        >
          <Text fontSize="lg" fontWeight="bold" textAlign="center">
            {Lang?.CHAT?.ERROR_BOUNDARY_TITLE || "Something went wrong."}
          </Text>
          <Text fontSize="sm" textAlign="center" maxW="22rem" color="gray.300">
            {Lang?.CHAT?.ERROR_BOUNDARY_SUBTITLE ||
              "Please try again. If the problem persists, contact support."}
          </Text>
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            my={"10px"}
            gap={"10px"}
            flexWrap={"wrap"}
          >
            <CopyFullError error={error} />
            <Button onClick={this.handleRetry} colorScheme="cyan">
              {Lang?.CHAT?.RETRY || "Retry"}
            </Button>
          </Flex>
        </Flex>
      );
    }
    return this.props.children;
  }
}

export default ChatErrorBoundary;
const CopyFullError = ({ error }) => {
  const toast = useToast();
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    const errorDetails = {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };

    const formattedError =
      typeof error == "string" ? error : JSON.stringify(errorDetails, null, 2);
    navigator.clipboard.writeText(formattedError).then(() => {
      setCopied(true);
      toast({
        title: "Copied to clipboard",
        description: "The error details have been copied.",
        status: "success",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    });
  };
  return (
    <Text
      textAlign={"center"}
      p={"5px"}
      borderRadius={"6px"}
      className="Btn"
      cursor={"pointer"}
      transition={".5s ease"}
      onClick={() => handleCopy()}
    >
      {copied ? "Copied!" : "Copy Details"}
    </Text>
  );
};
